import routes from '@modules/subprogram/subprogram-routes';
import store from '@modules/subprogram/subprogram-store';

export default {
  routes,
  store,
};
